import apiClient from "./apiClient";

export async function summariseMyOverview(task, { signal } = {}) {
  if (!["summary", "attention"].includes(task)) throw new Error("Unsupported George task");
  const response = await apiClient.post("/george/my-overview/summary", { task }, { signal });
  if (response.data?.scope !== "current_user_authorised_pinned_items" ||
      typeof response.data?.summary !== "string" || !response.data.summary.trim()) {
    throw new Error("George summary unavailable");
  }
  return response.data.summary;
}
